import { render, staticRenderFns } from "./CompetitionDetailComponent.vue?vue&type=template&id=60feab46&scoped=true"
import script from "./CompetitionDetailComponent.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60feab46",
  null
  
)

export default component.exports